const HOME_PATH = "/staff-search";
const DETAIL_PATH = HOME_PATH+ "/view";

export {
  HOME_PATH,  
  DETAIL_PATH,  
}